import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Login.css";
import heroImg from "../../assets/office.jpg";
import logo from "../../assets/logoavena.jpg";
import { useAuth } from "../../auth/AuthProvider";
import { ADMIN_CREDENTIALS } from "../../config/adminAuth";

export default function Login() {
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      if (id !== ADMIN_CREDENTIALS.id || password !== ADMIN_CREDENTIALS.password)
        throw new Error("Invalid ID or password");

      login(); // ✅ in-memory only
      const from = location.state?.from?.pathname || "/admin/blog";
      navigate(from, { replace: true });
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login">
      {/* Left hero */}
      <aside className="login__left" style={{ backgroundImage: `url(${heroImg})` }}>
        <div className="login__overlay" />
        <div className="login__copy">
          <div className="img-logo-admin">
            <img src={logo} alt="Avena Info Tech" className="login__brand-logo" />
          </div>
          <h1 className="login__kicker">JOIN OUR MARKETPLACE</h1>
          <h2 className="login__title">AVENA INFOTECH</h2>
          <p className="login__desc">
            Explore innovative IT solutions, trusted products, and enterprise-grade services — 
            all in one place. Partner with Avena InfoTech and empower your business with 
            technology that drives success.
          </p>
        </div>
      </aside>

      {/* Right form */}
      <main className="login__right">
        <div className="login-card">
          <h3 className="login-card__title">Admin Login</h3>
          {err && <div className="alert">{err}</div>}

          <form className="form" onSubmit={submit} noValidate>
            <label className="field">
              <span className="field__label">Admin ID</span>
              <input
                id="id"
                type="text"
                className="field__input"
                value={id}
                onChange={(e) => setId(e.target.value)}
                required
                placeholder="Enter admin ID"
                autoComplete="off"
              />
            </label>

            <label className="field">
              <span className="field__label">Password</span>
              <input
                id="password"
                type="password"
                className="field__input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                autoComplete="off"
              />
            </label>

            <button className="btn" type="submit" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner" aria-hidden="true" /> Checking…
                </>
              ) : (
                "Login to your Account"
              )}
            </button>
          </form>
        </div>

        <p className="login__foot">© {new Date().getFullYear()} Avena Info Tech</p>
      </main>
    </div>
  );
}
